import { render, staticRenderFns } from "./view-solo-driver-details.vue?vue&type=template&id=851059e2&"
import script from "./view-solo-driver-details.vue?vue&type=script&lang=js&"
export * from "./view-solo-driver-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports